import { styled } from 'styled-components';
import { WraperOptions, OptionItem } from '../options-block/styles';

const BoxCondition = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: auto;
`;
const WraperConditions = styled(WraperOptions)``;
const ConditionItem = styled(OptionItem)`
  cursor: auto;
  padding: 12px;
`;

export { BoxCondition, WraperConditions, ConditionItem };
